import { render, staticRenderFns } from "./tooltip-wrapper.vue?vue&type=template&id=8845d592&lang=pug&"
import script from "./tooltip-wrapper.vue?vue&type=script&lang=ts&"
export * from "./tooltip-wrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports